import { computed, provide } from 'vue';
import uniqueId from 'lodash/uniqueId';
import { useModel } from './component-lib.esm15.js';
import { addOrRemove } from '../utils/component-lib.esm7.js';
function useGroup(initialValue, onChange) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    multiple = false,
    groupName = 'group',
    selectable = true,
    provideValues = {}
  } = options;
  const selected = useModel(initialValue, onChange);
  const inputName = uniqueId(groupName);
  const multipleRef = computed(() => {
    return typeof multiple.value === 'boolean' ? multiple.value : multiple;
  });
  const selectableRef = computed(() => {
    return typeof selectable.value === 'boolean' ? selectable.value : selectable;
  });
  if (multipleRef.value && !Array.isArray(selected.value)) selected.value = [selected.value];
  function onToggle(itemValue) {
    if (multipleRef.value) {
      selected.value = addOrRemove(selected.value, itemValue);
    } else {
      selected.value = itemValue;
    }
  }
  provide(groupName, {
    isInGroup: true,
    selected,
    onToggle,
    inputName,
    selectable: selectableRef,
    ...provideValues
  });
  return {
    selected
  };
}
export { useGroup };